<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/list_crop_fields.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_crop_field_list_producers_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      producer_id: producer_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, producer?.fullname]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-leaf"></i
      ><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <!-- <div class="mt-8 flex flex-col md:flex-row justify-between items-center">
      <div class="panel-plain-label">
        <badge-default
          :label="total_rows + ' ' + $t('labels.total_number_crop_fields')"
        />
        <span class="space-actions" />
        <badge-default
          :label="total_inspections + ' ' + $t('labels.total_number_inspections')"
        />
      </div>
      <div class="flex flex-col-reverse md:flex-row-reverse gap-2">
        <white-button v-if="filtered" label="Limpiar" @click.prevent="clearFilters" />
        <white-button
          label="Filtrar"
          @click.prevent="filterCropFields"
        />

        <input
          type="text"
          v-model.trim="filters.name"
          :placeholder="$t('model.crop_field.name')"
          class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
        />
        <input
          type="text"
          v-model.trim="filters.week"
          :placeholder="$t('model.crop_field.week')"
          class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
        />
      </div>
    </div> -->


    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.name") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.crop") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.total_inspections") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.crop_field.quality_accepted_percent") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="crop_field in crop_fields"
                  :key="crop_field.id"
                >
                  <td class="table-cell">
                    {{ crop_field.week }}
                  </td>
                  <td class="table-cell-main">
                    {{ crop_field.name }}
                  </td>
                  <td class="table-cell">
                    {{ crop_field.crop?.name }}
                  </td>
                  <td class="table-cell">
                    {{ crop_field.total_inspections || "" }}
                  </td>
                  <td class="table-cell">
                    {{ crop_field.total_quality_accepted_percent || "" }}
                  </td>
                  <td class="table-cell-action">
                    <button class="link" @click="goToListTemplates(crop_field)">
                      <i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <table-paginator
      v-if="total_rows > rows_per_page"
      v-model="current_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    />
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/crop_field/list_crop_fields.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "AEProductionCropFieldQualityListCropFields",
  components: { TablePaginator },
  props: ["agro_exporter_id", "producer_id"],
  data() {
    return {
      load_data_general: false,
      producer: {},
      crop_fields: [],
      total_rows: 0,
      total_inspections: 0,
      current_page: 1,
      rows_per_page: 15,
      quality_templates: [],
      filtering: false,
      filtered: false,
      filters: {
        name: "",
        week: "",
      },
    };
  },
  computed: {
    can_filter() {
      return Object.values(this.filters).some(f => f !== "");
    }
  },
  methods: {
    fetchProducer: async function () {
      let response = await Requester.fetchProducer(
        this.agro_exporter_id,
        this.producer_id
      );
      this.producer = response.data;
    },
    fetchCropFields: async function () {
      let { data } = await Requester.fetchCropFields(
        this.agro_exporter_id,
        this.producer_id,
        {
          ...this.filters,
          current_page: this.current_page,
          rows_per_page: this.rows_per_page
        }
      );
      this.crop_fields = data.records;
      this.total_rows = data.total;
      this.total_inspections = data.total_inspections;
      this.load_data_general = true;
    },
    fetchQualityTemplates: async function () {
      let response = await Requester.fetchQualityTemplates(
        this.agro_exporter_id,
        this.producer_id
      );
      this.quality_templates = response.data;
    },
    filterCropFields: async function () {
      if (!this.filtering && this.can_filter) {
        this.filtering = true;
        this.current_page = 1;
        try {
          await this.fetchCropFields();
          this.filtered = true;
        } catch (error) {
          console.error("Error filtering crop fields:", error);
        } finally {
          this.filtering = false;
        }
      }
    },
    clearFilters: function () {
      this.filtering = false;
      this.filtered = false;
      this.filters = {
        name: "",
        week: "",
      };
      this.current_page = 1;
      this.fetchCropFields();
    },
    goToListTemplates: function (crop_field) {
      this.$router.push({
        name: "ae_quality_control_crop_field_list_templates_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          producer_id: this.producer_id,
          crop_field_id: crop_field.id
        }
      });
    }
  },
  watch:{
    rows_per_page: function () {
      this.fetchCropFields();
    },
    current_page: function () {
      this.fetchCropFields();
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchProducer();
        this.fetchCropFields();
        this.fetchQualityTemplates();
      })
    );
  }
};
</script>
